import { render, staticRenderFns } from "./BulkProjectCustomerInfo.vue?vue&type=template&id=67e4e42e&"
import script from "./BulkProjectCustomerInfo.vue?vue&type=script&lang=ts&"
export * from "./BulkProjectCustomerInfo.vue?vue&type=script&lang=ts&"
import style0 from "./BulkProjectCustomerInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports